import { TemplateElement, html, defineElement, classMap, when } from '@webtides/element-js';
import style from './full-width-teaser.css';
import '../../../chip/chip.js';
import { responsiveImage } from '../../../../directives/images.js';

// TODO: find a way to generically provide JSDOcs for the properties

/**
 * @property {ImageProperties} backgroundImage
 * @property {string} backgroundColor
 * @property {string} kicker
 * @property {string} headline
 * @property {string} text
 * @property {string} cardPosition
 * @property {'full' | 'contained'} width
 * @property {string} chipText
 * @property {string} chipVariant
 * @property {LinkProperties} link
 */
export default class FullWidthTeaser extends TemplateElement {
    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            backgroundImage: undefined,
            backgroundColor: 'green-medium',
            kicker: '',
            headline: '',
            text: '',
            cardPosition: 'left',
            width: 'full',
            chipText: '',
            chipVariant: 'primary',
        };
    }

    template() {
        const cardClasses = {
            'bg-green-medium': this.backgroundColor === 'green-medium',
            'bg-green-dark': this.backgroundColor === 'green-dark',
            'bg-violet-medium': this.backgroundColor === 'violet-medium',
            'bg-violet-dark': this.backgroundColor === 'violet-dark',
            'mr-auto': this.cardPosition === 'left',
            'ml-auto': this.cardPosition === 'right',
            'mx-auto': this.cardPosition === 'center',
        };
        return html`
            <div class="${this.width === 'full' ? 'container-full' : 'relative cms-component'} mb-40 md:mb-80">
                ${when(
                    this.backgroundImage?.srcset,
                    responsiveImage(
                        this.backgroundImage,
                        'absolute inset-0 w-full aspect-video md:aspect-auto md:h-full object-cover z-10 max-h-full',
                    ),
                )}
                <div class="relative container container-lg py-24 md:py-40 z-20">
                    <div
                        class="card w-full mt-112 md:mt-0 md:w-5/12 rounded-lg px-24 py-48 text-white ${classMap(
                            cardClasses,
                        )}"
                    >
                        ${when(
                            this.chipText,
                            html`
                                <mb-chip variant="${this.chipVariant}" text="${this.chipText}" class="mb-8"></mb-chip>
                            `,
                        )}
                        ${when(!this.chipText && this.kicker, html` <div class="mb-8">${this.kicker}</div> `)}
                        <h2 class="mb-24 text-balance text-[32px] lg:text-[42px]">${this.headline}</h2>
                        ${when(this.text, html` <p class="mb-24">${this.text}</p> `)}
                        ${when(
                            this.link?.url && this.link?.text,
                            html`<a href="${this.link.url}" class="Button btn btn-outline-light">${this.link.text}</a>`,
                        )}
                    </div>
                </div>
            </div>
        `;
    }
}

defineElement('mb-full-width-teaser', FullWidthTeaser);
